import { useState } from 'react';

// ReportLogoImage — story 4-107 (P06 §4). A missing/deleted/inaccessible
// logo asset falls back to a text identity rather than the browser's own
// broken-image glyph, mirroring
// `backend/src/services/pdf/pdfExport.service.js#logoImgWithFallback`'s
// backend twin (same real edge case either renderer can hit independently —
// a stale/rotated storage URL, a network hiccup, a revoked signed URL).
// Shared by every report logo spot (`ReportCoverPage`, `ReportRender.tsx`'s
// own header, `ReportLetterhead`'s three slots) — one fallback mechanism,
// not one per call site. One more "report-render layout piece with no prior
// design-system home" in the same family as `ReportCoverPage`/
// `ReportScoreStrip`/etc. (see `ReportLetterhead.tsx`'s own header comment
// for that family) — no dedicated `/app/design` gallery entry, same as its
// siblings.
export interface ReportLogoImageProps {
  src: string;
  alt?: string;
  fallbackText: string;
  className?: string;
  fallbackClassName?: string;
}

export function ReportLogoImage({
  src,
  alt = '',
  fallbackText,
  className,
  fallbackClassName = 'text-caption font-semibold text-muted-foreground',
}: ReportLogoImageProps): JSX.Element {
  const [failed, setFailed] = useState(false);
  if (failed) {
    return <span className={`${className ?? ''} ${fallbackClassName}`.trim()}>{fallbackText}</span>;
  }
  return <img src={src} alt={alt} onError={() => setFailed(true)} className={className} />;
}
